<div mat-dialog-title>
  <span>{{'action.exportAndSendRequest' | translate}}</span>
  <button [mat-dialog-close]="data">
    <i class="fa fa-times"></i>
  </button>
</div>
<mat-dialog-content>
  <!-- PART 2 -->
  <form [formGroup]="detailForm" (keydown.enter)="$event.preventDefault()">
    <h4 class="detail-title">{{'action.addEmailAddressForExport' | translate}}</h4>
    <div class="d-flex flex-wrap flex-item-baseline">
      <!-- NAME -->
      <div class="form-group">
        <div class="div-email">
          <div class="add-email">
            <input formControlName="email" type="text" class="form-control"
              [ngClass]="{'border-danger': f.email.invalid && (f.email.dirty || f.email.touched)}" id="email"
              placeholder="toto@example.com">

            <button class="btn-add icon-plus" (click)="addEmail()"></button>
          </div>

          @if (f.email?.errors && (f.email.dirty || f.email.touched)) {
            <label class="error">
              {{'error.email' | translate}}
            </label>
          }

          @for (email of emailList; track email) {
            <div class="list-email">
              <span  class="d-flex justify-content-center" >{{email}}</span>
              <button class="icon-minus-circle" (click)="removeEmail(email)"></button>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="wrap-file-actions">
      <button type="button" class="btn btn--primary" (click)="exportRequest()" [disabled]="btnDisabled">{{'action.export' | translate}}</button>
      <button type="button" class="btn btn--outline-grey-color ml-20" (click)="onNoClick()">{{'action.cancel' | translate}}</button>
    </div>
    <!-- Affichage l'état de l'envoi -->
    @if (messageSendSuccess == 'true') {
      <div>
        <div class="alert alert-success">
          {{'action.sendExportRequestValid' | translate}}
        </div>
      </div>
    }
    @if (messageSendSuccess == 'false') {
      <div>
        <div class="alert alert-error">
          {{'action.sendExportRequestError' | translate}}
        </div>
      </div>
    }
  </form>

</mat-dialog-content>
